import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';

type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'gold';

const TONE_MAP: Record<string, Tone> = {
  pending: 'neutral',
  received: 'info',
  in_review: 'warning',
  completed: 'success',
  signed: 'gold',
  delivered: 'success',
  active: 'success',
  expiring_soon: 'warning',
  expired: 'danger',
  archived: 'neutral',
};

const toneStyles: Record<Tone, string> = {
  neutral: 'bg-muted/60 text-muted-foreground',
  info: 'bg-info/15 text-info',
  success: 'bg-success/15 text-success',
  warning: 'bg-warning/15 text-warning',
  danger: 'bg-danger/15 text-danger',
  gold: 'bg-gold/15 text-gold',
};

/** i18n-aware status pill — maps a status key to a translated label + tone. */
export function StatusPill({ status }: { status: string }) {
  const { t } = useTranslation();
  const tone = TONE_MAP[status] ?? 'neutral';
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
        toneStyles[tone],
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {t(`status.${status}`, status)}
    </span>
  );
}
